import React from 'react';
import PropTypes from 'prop-types';
import { ActionLayerWrapper } from './ActionLayer.style';

// Flip side of the desktop miniscoreboard cards displayed on hover
const ActionLayer = ({
    hasButtons,
    buttons,
    className
}) => {
    if (!hasButtons) {
        return null;
    }

    return (
        <ActionLayerWrapper className={ className }>
            { buttons }
        </ActionLayerWrapper>
    );
};

ActionLayer.propTypes = {
    hasButtons: PropTypes.bool,
    buttons: PropTypes.array,
    className: PropTypes.string
};

export default ActionLayer;
